import React, {useState, useEffect} from 'react'
import './style.sass'
import { Link } from 'react-router-dom'

export function BtnFloatMenu(){
    const [showMenu, setShowMenu] = useState(false)

    const toggleMenuDost = () => {
        setShowMenu(!showMenu)
        //console.log('showMenu: ',showMenu)
    }

    return(
        <div className="contFloatMenu">
            <div className="btnDots" onClick={toggleMenuDost}></div>
            {showMenu &&
                <div className="floatMenu">
                    <ul>
                        {/* <li className="icoPF">
                            <Link to={"#"} >Preguntas frecuentes</Link>
                        </li> */}
                        <li className="icoLC">
                            <a href={"https://onecontact.searsmx.com:10440/clicktointeract/chat.aspx?oneContactInstance=sears&motive=Credito"} target="_blank" >Línea de crédito</a>
                        </li>
                        <li className="icoQS">
                            <a href="https://wa.me/5215591793394" target="_blank" >Quejas y sugerencias</a>
                        </li>
                        <li className="icoDC">
                            <a href={"/credito-claroshop/downloads/DIRECTORIO_DE_AGENCIAS_EXTERNAS_Y_NEGOCIADORES_DE_COBRANZA_SEARS.pdf"} download >Directorios de cobranza</a>
                        </li>
                    </ul>
                </div>
                
            }
        </div>
    )
}